import { Component } from '@angular/core';
import { RouterModule } from "@angular/router";

@Component({
  selector: 'kt-app-pricing-section',
  standalone: true,
  templateUrl: './pricing-section.component.html',
  styleUrl: './pricing-section.component.scss',
  imports: [RouterModule]
})
export class PricingSectionComponent {

}
